import React from "react";

export default function FAQ() {
  return <>TBA</>;
}
